import React from 'react';
import PropTypes from 'prop-types';
import CwToggleButtonGroup from '../cwtogglebuttongroup/CwToggleButtonGroup';

const CwToggleButtonBool = (props) => {
  const leftButton = {
    id: props.invert,
    name: props.leftButtonText
  };

  const rightButton = {
    id: !props.invert,
    name: props.rightButtonText
  };

  const toggleButtons = [
    leftButton, rightButton
  ];

  let selectedButton;
  if(props.invert){
    selectedButton = props.value ? leftButton : rightButton;
  } else {
    selectedButton = props.value ? rightButton : leftButton;
  }

  const handleOnChange = (item) => {
    if (!props.onChange) {
      return;
    }
    
    props.onChange(item.id);
  };

  return (
    <CwToggleButtonGroup cwId={props.cwId} toggleButtons={toggleButtons} value={selectedButton} onChange={handleOnChange}
    onFocus={props.onFocus} onBlur={props.onBlur} tabIndex={props.tabIndex}/>
  );
};

CwToggleButtonBool.propTypes = {
  /**
  * Connectwise element id to be used as unique identifier
  */
  cwId: PropTypes.string,
  /**
   * Used to control which toggle button is selected,
   * if true the right one is selected, false the left one is selected
   */
  value: PropTypes.bool,
  /**
   * Callback fired when one of the toggle buttons is clicked
   */
  onChange:PropTypes.func,
   /**
   * Callback fired when one of the toggle buttons is clicked
   */
  onFocus:PropTypes.func,
   /**
   * Callback fired when one of the toggle buttons is clicked
   */
  onBlur:PropTypes.func,
  /**
   * Text for the left toggle button
   */
  leftButtonText: PropTypes.string,
  /**
   * Text for the right toggle button
   */
  rightButtonText: PropTypes.string,
  /**
   * Used to control tab order
   */
  tabIndex: PropTypes.number,
  /**
   * Unused, added to satisfy pod element check
   */
  invalid: PropTypes.bool,
  /**
   * Default invert is false; meaning left button is false and right button is true
   * If invert is true, left button is true and right button is false
   */
  invert: PropTypes.bool,
};

CwToggleButtonBool.defaultProps = {
  tabIndex: 0,
  invert: false,
};

export default CwToggleButtonBool;


// WEBPACK FOOTER //
// ./src/components/cwtogglebuttonbool/CwToggleButtonBool.jsx